export const getExtraIconImageNameAccordingToPolicy = (policy: string): string => {
  switch (policy) {
    case 'SKIP_LINE':
      return 'skip-line'
    default:
      return policy.toLowerCase()
  }
}
